/* eslint-disable no-undef */
/* eslint-disable prettier/prettier */
import '@/assets/scss/styles.scss'

import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'

import { i18n } from './i18n'
import { Trans } from './plugins/translation'
import helpers from './helpers'

import VmqInput from '@maqe-vue/text-input'
import VueTheMask from 'vue-the-mask'
import VueMeta from 'vue-meta'

import VueCroppie from 'vue-croppie'
import 'croppie/croppie.css' // import the croppie css manually
import VueSocialSharing from 'vue-social-sharing'

import '@maqe-vue/text-input/dist/input.css'
import { mapActions, mapGetters } from 'vuex'

import vSelect from 'vue-select'
import 'vue-select/src/scss/vue-select.scss'

import VueCountryCode from 'vue-country-code'

Vue.use(VueSocialSharing)
Vue.use(VueTheMask)
Vue.use(VueCroppie)

Vue.component('v-input', VmqInput)
Vue.component('v-select', vSelect)
Vue.use(VueCountryCode)

Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans)
Vue.prototype.helpers = helpers
Vue.prototype.Trans = Trans

Vue.config.productionTip = false

axios.defaults.baseURL = `${process.env.VUE_APP_BACKEND_HOST}/`
axios.defaults.headers.common.Authorization = localStorage.getItem('token')
  ? `Bearer ${localStorage.getItem('token')}`
  : null
axios.defaults.validateStatus = (status) => {
  return status >= 200 && status <= 302
}

const checkConsent = function () {
  /*CHECKS IF ANALYTICS COOKIES ARE ENABLED*/
  if (document.cookie.indexOf('C0002%3A1') > -1) {

    (function (w, d, s, l, i) {
      w[l] = w[l] || []
      w[l].push({
        'gtm.start': new Date().getTime(),
        event: 'gtm.js',
      })
      var f = d.getElementsByTagName(s)[0],
        j = d.createElement(s),
        dl = l != 'dataLayer' ? '&l=' + l : ''
      j.async = true
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl
      f.parentNode.insertBefore(j, f)
    })(window, document, 'script', 'dataLayer', 'GTM-WZJV2C8')

    Vue.prototype.$gtm = { push: function (arg) { window.dataLayer.push(arg) } }
  }

  /*CHECKS IF TARGETING, ADVDERTISING and SOCIAL MEDIA COOKIES ARE ENABLED*/

  if (document.cookie.indexOf('C0004%3A1') > -1) {
    //TRIGGER TARGETING, ADVDERTISING and SOCIAL MEDIA SCRIPTS
  }

  /*CHECKS IF PREFERENCES COOKIES ARE ENABLED*/

  if (document.cookie.indexOf('C0007%3A1') > -1) {
    //TRIGGER PREFERENCES SCRIPTS
  }

  /*CHECKS IF PERFORMANCE COOKIES ARE ENABLED*/

  if (document.cookie.indexOf('C0008%3A1') > -1) {
    //TRIGGER PERFORMANCE SCRIPTS
  }
}

/*THIS HAPPENS WHEN THE USER CLICKS ON THE BANNER*/

document.addEventListener('OneTrustChanged', function () {
  //RUNS CONDITIONS AGAIN

  checkConsent()
})

//RUNS CONDITIONS ON PAGE LOAD

checkConsent()

export const bus = new Vue()

new Vue({
  data: () => ({
    windowWidth: window.innerWidth,
  }),
  computed: {
    ...mapGetters(['user', 'getIntensiveTotalProgress']),
    isMobile: function () {
      return this.windowWidth < 768;
    },
    isTablet: function () {
      return this.windowWidth < 1220 && this.windowWidth > 767;
    },

  },
  methods: {
    ...mapActions(['fetchSession', 'IntensivesTotalProgress', "SOCKET_CONNECT"]),
  },
  async mounted() {
    window.addEventListener('resize', () => {
      this.windowWidth = window.innerWidth
    })
    if (
      this.user &&
      !Object.keys(this.user).length &&
      (!process.env.VUE_APP_CLOSED || document.cookie.includes('access')) &&
      localStorage.getItem('token')
    ) {
      await this.fetchSession()
     
        
      if (
        this.user &&
        Object.keys(this.user).length &&
        this.user.username &&
        this.$gtm
      ) {
        await this.IntensivesTotalProgress()
        let percent = 0
        this.getIntensiveTotalProgress.forEach(
          (el) => (percent += el.progress_percent)
        )
        Math.round(percent / this.getIntensiveTotalProgress.length)
        this.$gtm.push({
          event: 'user_data',
          userId: this.user.username,
          uid: this.user.username,
          user_id: this.user.username,
          authDate: this.user.last_login,
          regDate: this.user.first_login_date || this.user.date_joined,
          progress: Math.round(percent / this.getIntensiveTotalProgress.length),
        })
      }
    }
  },
  watch: {
    'user.username': {
      handler: async function (n, o) {
        let percent = 0
        this.getIntensiveTotalProgress.forEach(
          (el) => (percent += el.progress_percent)
        )
        if (!o && n) {
          this.SOCKET_CONNECT()
          if (this.$gtm) {
            this.$gtm.push({
              event: 'user_data',
              userId: this.user.username,
              uid: this.user.username,
              user_id: this.user.username,
              authDate: this.user.last_login,
              regDate: this.user.first_login_date,
              progress: Math.round(
                percent / this.getIntensiveTotalProgress.length
              ),
            })
          }
        }
        if (o && !n) {
          if (this.$gtm) {
            this.$gtm.push({
              event: 'user_data',
              userId: 'undefined',
              authDate: 'undefined',
              regDate: 'undefined',
              progress: 'undefined',
            })
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
